module.exports = __webpack_public_path__ + "static/media/geelong-cats-football-logo.0a20a5c4.svg";